import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FocusGroup from './pages/NEW/FocusGroup';
// ss
function App() {
  return (
    <Router>
      <Routes>
              <Route path="/" element={<FocusGroup />} />
        
      </Routes>
    </Router>
  );
}

export default App;